module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/plant.f2b82478.png";